import Table, { ColumnsType } from "antd/lib/table";
import { TableRowSelection } from "antd/lib/table/interface";
import React from "react";
import { Icon } from "semantic-ui-react";
import { formatAsNaira } from "../../../helpers/helpers";
import { InvoiceTableRow } from "../types";
import { assignmentsTableRenderer } from "./assignmentsTableRenderer";

export interface OrderInvoicesTableProps {
  invoiceRows: InvoiceTableRow[];
  orderCode: string;
  selectable?: TableRowSelection<InvoiceTableRow>;
  moveTo: (path: string) => void;
}

export const orderInvoicesTableRenderer = ({
  invoiceRows,
  orderCode,
  selectable,
  moveTo,
}: OrderInvoicesTableProps) => {
  const columns: ColumnsType<InvoiceTableRow> = [
    {
      title: "Invoice No",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          #{record.invoice?.invoiceNumber}
        </p>
      ),
      width: "5%",
    },
    {
      title: "Recipient Name",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          {record.invoice?.recipient.name}
        </p>
      ),
      width: "15%",
    },
    {
      title: "Assignments",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          {record.assignmentTableRows.length}
        </p>
      ),
      width: "5%",
      sorter: (a, b) =>
        a.assignmentTableRows.length - b.assignmentTableRows.length,
    },
    {
      title: "Billing Address",

      width: "29%",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          {record.invoice?.recipient.address.join(", ")}
        </p>
      ),
    },
    {
      title: "Total Cost",
      width: "13%",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          {formatAsNaira(record.invoice?.totalCost ?? 0)}
        </p>
      ),
    },
    {
      title: "Amount Due",
      width: "13%",
      render: (text, record) => (
        <p className='a-orderDetail__tableText'>
          {formatAsNaira(record.invoice?.amountDue ?? 0)}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      width: "20%",
      render: (text: any, record) => {
        return (
          <button
            className='a-orderDetail__tableButton'
            onClick={() => {
              moveTo(`/invoices/${record.invoice?.id}`);
            }}
          >
            View Invoice
          </button>
        );
      },
    },
  ];

  return (
    <div className='o-orderDetail__tableWrapper'>
      <Table
        className='o-orderDetail__table'
        indentSize={15}
        {...(selectable && {
          rowSelection: selectable,
        })}
        expandable={{
          expandedRowRender: (record) =>
            assignmentsTableRenderer({
              assignments: record.assignmentTableRows,
              orderCode,
              moveTo,
            }),
        }}
        pagination={false}
        columns={columns}
        dataSource={invoiceRows.map((data) => {
          return {
            key: data.invoice?.id,
            ...data,
          };
        })}
      />
    </div>
  );
};
